var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardFuelType3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 96,
    height: 99,
    viewBox: "0 0 96 99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_2511",
    "data-name": "Rechteck 2511",
    width: 72,
    height: 72,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Komponente_53_1",
    "data-name": "Komponente 53 \\u2013 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_431",
    "data-name": "Ellipse 431",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 48,
    cy: 49.5,
    rx: 48,
    ry: 49.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 48,
    cy: 49.5,
    rx: 47,
    ry: 48.5,
    fill: "none"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "icon--erdoel",
    transform: "translate(12 12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3298",
    "data-name": "Gruppe 3298",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_2510",
    "data-name": "Rechteck 2510",
    width: 40,
    height: 60,
    rx: 3,
    transform: "translate(16 8)",
    fill: "none",
    stroke: "#004a5a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5834",
    "data-name": "Pfad 5834",
    d: "M20,6V5.5A1.5,1.5,0,0,1,21.5,4h9A1.5,1.5,0,0,1,32,5.5V8H19.937Z",
    fill: "none",
    stroke: "#004a5a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_542",
    "data-name": "Linie 542",
    x2: 17.547,
    transform: "translate(40.453 28)",
    fill: "none",
    stroke: "#004a5a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_543",
    "data-name": "Linie 543",
    x2: 17.746,
    transform: "translate(14 28)",
    fill: "none",
    stroke: "#004a5a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_544",
    "data-name": "Linie 544",
    x2: 11.485,
    transform: "translate(46.515 48)",
    fill: "none",
    stroke: "#004a5a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_545",
    "data-name": "Linie 545",
    x2: 11,
    transform: "translate(14 48)",
    fill: "none",
    stroke: "#004a5a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5835",
    "data-name": "Pfad 5835",
    d: "M25.986,40.227a10.973,10.973,0,0,0-.97,5.147A11,11,0,0,0,47,44.78a10.944,10.944,0,0,0-.99-4.561L37.175,20.791a1.191,1.191,0,0,0-2.025-.016S26.012,40.169,25.986,40.227Z",
    fill: "none",
    stroke: "#004a5a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5836",
    "data-name": "Pfad 5836",
    d: "M29.846,44.533A6.392,6.392,0,0,0,34.2,50.222",
    fill: "none",
    stroke: "#004a5a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardFuelType3);
export default __webpack_public_path__ + "static/media/dashboard-fuel-type-3.c44b1ad42449709e8d4d27d4a1143aba.svg";
export { ForwardRef as ReactComponent };